import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { pcmpStatusCatalogSchema, type PcmpStatusCatalog } from '../types/pcmpQueue.types';

export const pcmpStatusQueryKeys = {
  catalog: () => ['pcmp-statuses'] as const,
};

// Fixed vocabulary; it only changes with an API release.
export const pcmpStatusCatalogQueryOptions = () =>
  queryOptions({
    queryKey: pcmpStatusQueryKeys.catalog(),
    queryFn: async (): Promise<PcmpStatusCatalog> => {
      const res = await apiClient.get(API.pcmpStatus.catalog);
      return pcmpStatusCatalogSchema.parse(res.data);
    },
    staleTime: Infinity,
  });
